import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  props: ['teamId'],
  data: function data() {
    return {
      dialogFormVisible: false,
      selectedCapacityId: '',
      formData: {
        student_id: '',
        score: []
      },
      allCapacityList: [],
      abilityList: [],
      reqLoading: false,
      rules: {
        value: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getAllCapacityListFn();

              case 2:
                if (!data) {
                  _context.next = 7;
                  break;
                }

                _this.formData.student_id = data.student_id;
                _this.formData.score = [];
                _context.next = 7;
                return _this.getAbilityListFn();

              case 7:
                _this.dialogFormVisible = true;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
      this.formData = {
        student_id: '',
        score: []
      };
      this.selectedCapacityId = '';
      this.abilityList = []; // 重置表单验证

      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
    },
    getAllCapacityListFn: function getAllCapacityListFn() {
      var _this2 = this;

      this.$api.getAbilityTagsList({
        page: 1,
        page_size: 1000,
        team_id: this.teamId
      }).then(function (res) {
        if (res.code == 200) {
          _this2.allCapacityList = res.data.data;

          if (_this2.abilityList.length > 0) {
            _this2.filterAllCapacityList();
          }
        }
      });
    },
    getAbilityListFn: function getAbilityListFn() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this3.$api.AbilityList({
                  student_id: _this3.formData.student_id
                });

              case 3:
                res = _context2.sent;

                if (!(res.code == 200)) {
                  _context2.next = 10;
                  break;
                }

                _this3.abilityList = res.data;
                _this3.formData.score = [];

                _this3.abilityList.forEach(function (item) {
                  _this3.formData.score.push({
                    id: item.tag_id,
                    name: item.tag_name,
                    value: item.score || ''
                  });
                });

                _context2.next = 10;
                return _this3.filterAllCapacityList();

              case 10:
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                _this3.$message.error('获取能力标签数据失败');

                console.error(_context2.t0);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 12]]);
      }))();
    },
    filterAllCapacityList: function filterAllCapacityList() {
      var existTagIds = this.abilityList.map(function (item) {
        return item.tag_id;
      }); // 过滤allCapacityList，只保留不在existTagIds中的项

      this.allCapacityList = this.allCapacityList.filter(function (item) {
        return !existTagIds.includes(item.id);
      });
    },
    addContent: function addContent() {
      var _this4 = this;

      if (!this.selectedCapacityId) {
        this.$message.warning('请先选择要添加的能力标签');
        return;
      }

      var selectedItem = this.allCapacityList.find(function (item) {
        return item.id == _this4.selectedCapacityId;
      });

      if (!selectedItem) {
        this.$message.error('选中的标签不存在');
        return;
      }

      this.formData.score.push({
        id: selectedItem.id,
        name: selectedItem.name,
        value: ''
      });
      this.allCapacityList = this.allCapacityList.filter(function (item) {
        return item.id != _this4.selectedCapacityId;
      });
      this.selectedCapacityId = '';
    },
    removeContent: function removeContent(domain) {
      this.formData.score = this.formData.score.filter(function (item) {
        return item.id != domain.id;
      });
      var recoverItem = {
        id: domain.id,
        name: domain.name
      };
      this.allCapacityList.push(recoverItem);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    _this5.reqLoading = true;
                    var data = JSON.parse(JSON.stringify(_this5.formData));
                    data.score = _this5.formData.score.map(function (item) {
                      var newObj = {};
                      newObj.tag_id = item.id;
                      newObj.score = item.value;
                      return newObj;
                    });
                    console.log("data===", data);

                    _this5.$api.subAbility(data).then(function (res) {
                      if (res.code == 200) {
                        _this5.reqLoading = false;

                        _this5.$message.success('操作成功');

                        _this5.$emit('change');

                        _this5.dialogFormVisible = false;
                      } else {
                        _this5.reqLoading = false;

                        _this5.$message.error(res.msg);
                      }
                    }).catch(function (errr) {
                      _this5.reqLoading = false;
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};